/** @format */

module.exports = {
  publicKey: "7C3ECC38FAFDB461CCB5937E9C1DB9FB",
  hostnameId: "luckydays",
  partnerId: "luckydays",
  partnerName: "Luckydays",
};



// WEBPACK FOOTER //
// ./src/partners/config/partner.js